import { gql } from "gql";

export const REMOVE_DYNAMIC_ATTRIBUTE = gql(/* GraphQL */ `
  mutation RemoveDynamicAttribute($id: ID!) {
    removeDynamicAttribute(id: $id)
  }
`);
